export default __webpack_public_path__ + "static/media/399.062fde4f.png";